import { useRef } from "react"
import PropTypes from "prop-types"
import { get, map, size, some, findIndex } from "lodash"
import classNames from "classnames"
import useResizeObserver from "hooks/resize-observer"
import Category from "./category"

import "./styles.scss"

// Check if any of the categories will have scrolling so we can align all the categories correctly
function aboveScrollTreshold(categories) {
  return some(categories, category => size(get(category, "factors")) > 10)
}

export default function FactorCategories({ categories, getValues, valueClassNames, getColumnColorStyle, firstOpened }) {
  const categoriesRef = useRef()
  const openedIndex = firstOpened && findIndex(categories, ({ factors }) => size(factors))

  // ResizeObserver is used to updated the Ellipsable component's width to always take the maximum width available
  // It prevents having truncated text with ellipsis when there would be enough space to render it
  const [width] = useResizeObserver(categoriesRef)

  return <div className={classNames("component_factor-categories", { scrollable: aboveScrollTreshold(categories) })}>
    {map(categories, (category, index) => {
      return <Category
        key={category.id}
        ref={index === 0 ? categoriesRef : undefined}
        {...{ ...category,
          getValues,
          getColumnColorStyle,
          maxLabelWidth: width,
          opened: index === openedIndex,
          valueClassNames,
        }}
      />
    },
    )}
  </div>
}

FactorCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  getValues: PropTypes.func.isRequired,
  getColumnColorStyle: PropTypes.func,
  firstOpened: PropTypes.bool,
  valueClassNames: PropTypes.array,
}
